import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sc-animate-arrows',
  templateUrl: './animate-arrows.component.html',
  styleUrls: ['./animate-arrows.component.scss']
})
export class AnimateArrowsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
